import Page from '@/components/Page'
import { ScrollList } from '@/components/ScrollList'
import { SearchResult } from '@/components/Search'
import SearchBar from '@/components/Search/SearchBar'
import useSearch from '@/components/Search/useSearch'
import { css } from '@emotion/react'
import { createFileRoute } from '@tanstack/react-router'
import { useTitle } from 'react-use'
import { z } from 'zod'

const searchSchema = z.object({
	q: z.string().catch(''),
})

type SearchParams = z.infer<typeof searchSchema>

export const Route = createFileRoute('/search')({
	component: SearchPage,
	validateSearch: (search: SearchParams) => {
		const { q } = searchSchema.parse(search)
		return {
			q: decodeURIComponent(q),
		}
	},
})

function SearchPage() {
	const keywords = Route.useSearch({
		select: (params) => params.q,
	})

	const { data, words, fetchNext, isRefreshing } = useSearch(keywords)

	useTitle(`${keywords} - 即刻搜索`)
	return (
		<Page onReachPageBottom={fetchNext}>
			<div
				css={css`
					margin: 20px 0 0;
					padding: 12px 0;
					position: sticky;
					top: 0;
					z-index: 3;
				`}
			>
				<SearchBar defaultValue={keywords} />
			</div>
			<ScrollList>
				<SearchResult data={data} highlightWords={words} isLoading={isRefreshing} />
			</ScrollList>
		</Page>
	)
}
